import * as React from 'react'
import { connect } from 'react-redux'
import { getPopularQuestions, navigateToArticle } from '../../actions/answers'
import { popularQuestionsSelector, popularQuestionsStatusSelector } from '../../selectors/popularquestions'
import { currentParamsSelector } from '../../selectors/navigation'
import { Article } from './popularArticle'

import '../../sass/answers/popularquestions.scss'
import { RootState } from '../../types/rootstate'

interface StateProps {
  popularQuestions: RootState['popularQuestions']['key']['popularQuestions']
  status: RootState['popularQuestions']['key']['status']
  params: RootState['navigation']['navigationStacks']['key']['history'][0]['params']
}

interface DispatchProps {
  getPopularQuestions: (userId: number, answersId: number, numberOfItems: number, categoryIds: string) => void
  navigateToArticle: (userId: number, answersId: number, articleId: number) => void
}

interface OwnProps {
  numberOfItems: number
  categoryIds: string
}

type MainProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state: RootState, ownProps: OwnProps): StateProps {
  return {
    popularQuestions: popularQuestionsSelector(state, ownProps),
    status: popularQuestionsStatusSelector(state, ownProps),
    params: currentParamsSelector(state)
  }
}

function mapDispatchToProps (dispatch): DispatchProps {
  return {
    getPopularQuestions: (userId, answersId, numberOfItems, categoryIds) =>
      dispatch(getPopularQuestions(userId, answersId, numberOfItems, categoryIds)),
    navigateToArticle: (userId, answersId, articleId) =>
      dispatch(navigateToArticle(userId, answersId, articleId))
  }
}

interface MainState {}

class PopularQuestionsComponent extends React.Component<MainProps, MainState> {

  componentWillMount () {
    this.props.getPopularQuestions(
      this.props.params.userId,
      this.props.params.formId,
      this.props.numberOfItems,
      this.props.categoryIds
    )
  }

  handleArticleClick = (id: number) => {
    this.props.navigateToArticle(
      this.props.params.userId,
      this.props.params.formId,
      id
    )
  }

  render () {
    return (
      <div className='col-xs-12 center-block'>
        <div className='answers-popular-items'>
          <ul className='list-group'>
            {this.props.popularQuestions.map((article) =>
              <Article
                key={article.id}
                article={article}
                onClick={this.handleArticleClick} />
              )}
          </ul>
        </div>
      </div>
    )
  }
}

const PopularQuestions = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(PopularQuestionsComponent)

export {
  PopularQuestions
}
